export default class ImageDownloadLocator {
  public idImageDownloadLocator: number = 0;
  public locatorName: string = "";
  public locatorValue: string = "";
}
